export const enableDragging = () => {
    const dragItem = document.getElementById("draggable");
    let offsetX = 0, offsetY = 0, isDragging = false;

    dragItem.addEventListener("mousedown", (e) => {
        isDragging = true;
        offsetX = e.clientX - dragItem.offsetLeft;
        offsetY = e.clientY - dragItem.offsetTop;
        document.body.style.userSelect = "none"; // prevent text selection
    });

    document.addEventListener("mousemove", (e) => {
        if (isDragging) {
            dragItem.style.left = `${e.clientX - offsetX}px`;
            dragItem.style.top = `${e.clientY - offsetY}px`;
        }
    });

    document.addEventListener("mouseup", () => {
        isDragging = false;
        document.body.style.userSelect = "auto";
    });
}
